import { supabase } from 'clients/supabase'
import { toast } from 'react-hot-toast'

export async function updateAnalytics(data: { name: string; type: 'resource' | 'theme' | 'document'; session_id: number }) {
	try {
		if (data.session_id) {
			const { error } = await supabase.from('core_adoption_session_logs').insert(data)
			if (error) throw new Error(error.message)
		}
	} catch (error: any) {
		toast.error(error.message)
	}
}
